module.exports = __webpack_public_path__ + "static/media/lixiaofeng.693d4a10.png";